import { useState } from "react";
import { toast } from "sonner";
import { FileDown, Loader2 } from "lucide-react";
import { api, formatErr } from "@/lib/api";

async function downloadInvoice(path) {
  const res = await api.get(path, { responseType: "blob" });
  const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || "invoice.pdf";
  const url = URL.createObjectURL(res.data);
  const a = Object.assign(document.createElement("a"), { href: url, download: name });
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const InvoiceButton = ({ path, testid, label = "Invoice", className = "asv-btn-ghost !py-2" }) => {
  const [busy, setBusy] = useState(false);
  const run = async (e) => {
    e.stopPropagation();
    setBusy(true);
    try { await downloadInvoice(path); } catch (err) { toast.error(err?.response?.status === 404 ? "Invoice not found" : formatErr(err)); } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={run} disabled={busy} className={`inline-flex items-center gap-1.5 ${className}`} data-testid={testid}>
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FileDown className="h-3.5 w-3.5" />}{label}
    </button>
  );
};
